<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <header-page titleText="Assinatura de Recibos" titleIcon="fal fa-hands" />



      <v-container>
        <v-row class="d-flex align-center justify-between">
          <v-col>
            <v-flex xs12 sm8 class="py-2">
              <v-btn-toggle v-model="tab" mandatory>
                <v-btn text rounded large class="px-12" value="1">
                  Pendentes de assinatura
                </v-btn>
                <v-btn text rounded large class="px-12" value="2">
                  Assinados
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-col>
          <v-col cols="12" md="3" hidden>
            <v-text-field
              outlined
              dense
              label="Buscar doador..."
              hide-details="auto"
              append-icon="fal fa-search"
              class="d-flex align-end justify-end"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3" v-if="councilEntities.length">
            <v-combobox
                :items="councilEntities"
                item-text="entityName"
                item-value="entityId"
                label="Conselho"
                outlined
                hide-details="auto"
                required
                v-model="selectedEntity"
            ></v-combobox>
          </v-col>

        </v-row>
        <v-row class="d-flex align-center justify-between">
          <v-col>
            <v-flex>
              <v-btn
                  v-if="allowToSign"
                :disabled="selected.length == 0"
                :hidden="tab != 1"
                color="secondary"
                large
                rounded
                depressed
                @click="certisignRequest()"
              >
                <v-icon left>mdi-pencil-box-outline</v-icon> Assinar
                <v-badge
                  v-if="selected.length > 0"
                  :content="selected.length"
                  inline
                >
                </v-badge>
              </v-btn>
              <v-btn
                  :disabled="selected.length == 0"
                  color="error"
                  large
                  rounded
                  depressed
                  @click="batchCancelReceipt(selectedReceiptIds)"
              >
                <v-icon left>mdi-cancel</v-icon> Cancelar
                <v-badge
                    color="primary"
                    v-if="selected.length > 0"
                    :content="selected.length"
                    inline
                >
                </v-badge>
              </v-btn>
            </v-flex>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="showCancelModal" persistent max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">Deseja realmente cancelar o recibo?</h5>
          </v-card-title>
          <v-card-text>
            Após cancelar o recibo, um novo será gerado em alguns instantes. É recomendável que se altere os informações necessárias antes de cancelar o recibo, por exemplo, presidente e/ou representante do Conselho
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showCancelModal = false"
              >Sair</v-btn
            >
            <v-btn
              color="error"
              rounded
              large
              depressed
              class="px-12"
              @click="cancelReceipt(selectedDonation.receiptId)"
              >Confirmar cancelamento</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showSignersModal" persistent max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">Responsáveis pelas assinaturas</h5>
          </v-card-title>
          <v-card-text>
            <div v-if="selectedDonation && selectedDonation.firstSigner">
              {{ selectedDonation.firstSigner.name }} 
              <v-icon class="fa-2x" outlined fab v-bind:color="selectedDonation.firstSigner.done ? 'success' : 'error'"> {{ selectedDonation.firstSigner.done ? 'mdi-check' : 'mdi-close' }} </v-icon>
              <br />
            </div>
            <div v-if="selectedDonation && selectedDonation.secondSigner">
              {{ selectedDonation.secondSigner.name }} 
              <v-icon class="fa-2x" outlined fab v-bind:color="selectedDonation.secondSigner.done ? 'success' : 'error'"> {{ selectedDonation.secondSigner.done ? 'mdi-check' : 'mdi-close' }} </v-icon> <br />
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showSignersModal = false"
              >Fechar</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Recibos pendentes de assiantura -->
      <v-container v-if="tab == 1" class="px-6">
        <v-row>
          <template>
            <v-expansion-panels multiple :focusable="true">
              <v-expansion-panel
                v-bind:key="generated.institutionName"
                v-for="generated in pendingSignList.generated"
              >
                <v-expansion-panel-header>
                  <v-row no-gutters>
                    <v-col cols="8"
                      >Instituição: {{ generated.institutionName }}</v-col
                    >
                    <v-col cols="2">Qtd: {{ generated.count }}</v-col>
                    <v-col cols="2"
                      >Total:
                      {{ formatterHelper.formatMoney(generated.total) }}</v-col
                    >
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    class="br-4 no-wrap table-traduction mb-2"
                    :headers="headers"
                    :items="generated.donations"
                    item-key="donationId"
                    no-data-text="Nenhum resultado encontrado"
                    :loading="loading"
                    :show-select="allowToSign || isAdminOrBenefactor"
                    v-model="selected"
                    :hide-default-footer="false"
                    :footer-props="{itemsPerPageText: 'Recibos por página', pageText: '{0}-{1} de {2}', itemsPerPageAllText: 'Todos'}"
                  >
                    <template v-slot:item.amount="{ item }">
                      {{ formatterHelper.formatMoney(item.amount) }}
                    </template>
                    <template v-slot:item.donorDocument="{ item }">
                      {{ formatterHelper.formatDocument(item.donorDocument) }}
                    </template>
                    <template v-slot:item.donationDate="{ item }">
                      {{ formatterHelper.formatDate(item.donationDate) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      
                      <v-icon
                        title="Assinantes"
                        class="fa-2x"
                        @click="showModalSigners(item)"
                        outlined
                        fab
                        color="primary"
                        >mdi-fingerprint</v-icon
                      >

                      <v-icon
                        title="Pré-visualizar"
                        class="fa-2x"
                        @click="signedPreview(item.receiptId)"
                        outlined
                        fab
                        color="secondary"
                        >mdi-file-pdf</v-icon
                      >

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            title="Cancelar"
                            class="fa-2x"
                            @click="showModalCancel(item)"
                            outlined
                            fab
                            color="error"
                            >mdi-file-cancel-outline</v-icon
                          >
                        </template>
                        <span
                          >Ao cancelar um recibo, ele será excluído e um novo
                          com as informações atualizadas estará disponível
                          amanhã.</span
                        >
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-row>
      </v-container>

      <!-- Recibos assinados -->
      <v-container v-if="tab == 2" class="px-6">
        <v-row>
          <template>
            <v-expansion-panels multiple :focusable="true">
              <v-expansion-panel
                v-bind:key="signed.institutionName"
                v-for="signed in pendingSignList.signed"
              >
                <v-expansion-panel-header>
                  <v-row no-gutters>
                    <v-col cols="8"
                      >Instituição: {{ signed.institutionName }}</v-col
                    >
                    <v-col cols="2">Qtd: {{ signed.count }}</v-col>
                    <v-col cols="2"
                      >Total:
                      {{ formatterHelper.formatMoney(signed.total) }}</v-col
                    >
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    class="br-4 no-wrap table-traduction mb-2"
                    :headers="headers"
                    :items="signed.donations"
                    item-key="donationId"
                    no-data-text="Nenhum resultado encontrado"
                    :loading="loading"
                    :show-select="isAdminOrBenefactor"
                    v-model="selected"
                    :hide-default-footer="false"
                    :footer-props="{itemsPerPageText: 'Recibos por página', pageText: '{0}-{1} de {2}', itemsPerPageAllText: 'Todos'}"
                  >
                    <template v-slot:item.amount="{ item }">
                      {{ formatterHelper.formatMoney(item.amount) }}
                    </template>
                    <template v-slot:item.donorDocument="{ item }">
                      {{ formatterHelper.formatDocument(item.donorDocument) }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon
                        title="Assinantes"
                        class="fa-2x"
                        @click="showModalSigners(item)"
                        outlined
                        fab
                        color="primary"
                        >mdi-fingerprint</v-icon
                      >
                      <v-icon
                        title="Visualizar"
                        class="fa-2x"
                        @click="signedPreview(item.receiptId)"
                        outlined
                        fab
                        color="secondary"
                        >mdi-file-pdf-box</v-icon
                      >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            title="Cancelar"
                            class="fa-2x"
                            @click="showModalCancel(item)"
                            outlined
                            fab
                            color="error"
                            >mdi-file-cancel-outline</v-icon
                          >
                        </template>
                        <span
                          >Ao cancelar um recibo, ele será excluído e um novo
                          com as informações atualizadas estará disponível
                          amanhã.</span
                        >
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import HeaderPage from "@/components/HeaderPage";
import ReceiptService from "@/scripts/services/receipt.service";
import Routes from "@/router/names.js";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import CommonHelper from '@/scripts/helpers/common.helper'

export default {
  name: "Receipt",
  components: {
    NavBar,
    HeaderPage
  },
  data: () => ({
    routes: Routes,
    receiptService: new ReceiptService(),
    loading: false,
    formatterHelper: FormatterHelper,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2
    },
    showFilterDialog: false,
    pendingSignList: [],
    selected: [],
    tab: 1,
    showSignersModal: false,
    showCancelModal: false,
    signerModal: {
      firstSigner: { name: "", occupation: "", done: false },
      secondSigner: { name: "", occupation: "", done: false }
    },
    councilEntities: [],
    selectedEntity: null,
    selectedDonation: null
  }),
  mounted() {
    this.addCertisignScripts();  
  },
  created(){
    
    this.selectedEntity = { entityId: parseInt(this.loggedEntityId), entityName: "" };
    this.loadCouncilEntityList();
    this.loadPendingSignList(this.selectedEntity.EntityId);
  },
  computed: {
    ...mapGetters("userModule", ["loggedEntityId","isAdminOrBenefactor"]),
    startDateMax() {
      if (this.endDate) return this.endDate;
      return new Date();
    },
    headers() {
      return [
        {
          text: "Id doação",
          value: "donationId",
          download: true
        },
        {
          text: "Recibo",
          value: "receiptOrderNumber",
          download: true
        },
        {
          text: "Nome Doador",
          value: "donorName",
          download: true
        },
        {
          text: "CPF/CNPJ Doador",
          value: "document",
          formatter: this.formatDocument,
          download: true
        },
        {
          text: "Valor",
          value: "amount",
          formatter: FormatterHelper.formatMoney,
          download: true
        },
        {
          text: "Data de doação",
          value: "conciliationDate",
          //formatter: this.formatDate,
          download: true
        },
        {
          text: "Status",
          value: "status",
          //formatter: FormatterHelper.formatDonationStatus,
          download: true
        },

        {
          text: "",
          value: "actions",
          //formatter: FormatterHelper.formatDonationStatus,
          download: true
        }
      ];
    },
    receiptSelected() {
      let docs = [];
      for (let p = 0; p < this.selected.length; p++) {
        let receipt = this.selected[p];
        docs.push(receipt.certisignKey);
      }
      return docs;
    },
    selectedReceiptIds() {
      let docs = [];
      for (let p = 0; p < this.selected.length; p++) {
        let receipt = this.selected[p];
        docs.push(receipt.receiptId);
      }
      return docs;
    },
    allowToSign() {
      return this.pendingSignList.document != "";
    },
    allowToCancel() {
      return this.pendingSignList.document != "";
    }
  },
  watch:{
    selectedEntity: function(entity){
      this.loadPendingSignList(entity.entityId);
    }
  },
  methods: {
    customSort(items, index, isDescending) {
      // The following is informations as far as I researched.
      // items: 'food' items
      // index: Enabled sort headers value. (black arrow status).
      // isDescending: Whether enabled sort headers is desc
      items.sort((a, b) => {
        if (index === 'conciliationDate') {
          console.log(a,b)
          if (isDescending) {
            return b.conciliationDate.split('/').reverse().join('-') - a.conciliationDate.split('/').reverse().join('-');
          } else {
            return a.conciliationDate.split('/').reverse().join('-') - b.conciliationDate.split('/').reverse().join('-');
          }
        }
      });

      return items;
    },
    showModalSigners(donation){
      this.selectedDonation = donation;
      this.showSignersModal = true;
    },
    showModalCancel(donation){
      this.selectedDonation = donation;
      this.showCancelModal = true;
    },
    addCertisignScripts(){
      let script = document.createElement("script");
      script.async = true;
      script.setAttribute(
        "src",
        "https://portaldeassinaturas.com.br/Scripts/Integration/certisign-client-integration-min.js?v=2"
      );
      document.head.appendChild(script);

      let css = document.createElement("link");
      css.setAttribute("rel", "stylesheet");
      css.setAttribute(
        "href",
        "https://portaldeassinaturas.com.br/Content/Integration/certisign-client-integration-min.css?v=2"
      );
      document.head.appendChild(css);
    },
    formatDate(date) {
      return FormatterHelper.formatDate(date);
    },

    loadPendingSignList() {
      const entityId = this.selectedEntity.entityId
      //this.$route.query.councilEntityId || 
      if(entityId > 1){
      this.receiptService
        .receiptList(entityId)
        .then(this.loadPendingSignListCallback);
      }
    },
    loadPendingSignListCallback(data) {
      this.pendingSignList = data;
    },

    loadCouncilEntityList() {
      console.log('entity: ', this.selectedEntity)
      if(this.selectedEntity.entityId == 1){
        this.receiptService
          .councilEntityList()
          .then(this.loadCouncilEntityListCallback);
      }
    },
    loadCouncilEntityListCallback(data) {
      this.councilEntities = data;
      if(data.length > 0){
        this.selectedEntity = data[0]
        this.loadPendingSignList();
      }
    },

    renderSignerModal(firstSigner, secondSigner) {
      this.signerModal.firstSigner = firstSigner;
      this.signerModal.secondSigner = secondSigner;
      this.showSignersModal = true;
    },

    certisignRequest() {
      console.log("Receipts.certisignRequest");
      var url = process.env.VUE_APP_API_CERTISIGN || 'https://izisign.com.br/Assinatura/AssinarLoteFrame';

      var confirmConfig = {
        textOkButton: "Sim",
        textCancelButton: "Não",
        textMessage:
          "Interromper o processo de assinatura causará inconsistência nos status das assinaturas já efetuadas. No entanto, da próxima vez que tentar assinar os status serão atualizados. Deseja realmente interromper o processo de assinatura em lote?"
      };

      var docs = this.receiptSelected;
      var signeds = [];
      const self = this;

      console.log("Receipts.certisignRequest.url:",url);
      console.log("Receipts.certisignRequest.confirmConfig:",JSON.stringify(confirmConfig));
      new window.CertisignIntegration(url, 560, 560, false, confirmConfig)
        .sign(docs, self.pendingSignList.document)
        .onSignCompleted(function(signStatus) {
          console.log("Receipts.certisignRequest.signStatus:",signStatus);
          if (Array.isArray(signStatus)) {
            for (var i = 0; i < signStatus.length; i++) {
              var result = signStatus[i];
              //comentando verificacao de status para criterio de homologacao, pois a assinatura esta dando problema no ambiente de homologacao
              if (result == 0 || result == 1) {
                signeds.push(docs[i]);
              }
            }
          } else {
            if (signStatus == 0 || signStatus == 1) {
              signeds.push(docs[0]);
            }
          }
          if (signeds.length > 0) {
            self.saveSigned(signeds);
          }
          //console.log(signeds);
        });
    },

    saveSigned(docs) {
      this.receiptService.saveReceiptSigned(this.loadPendingSignList, docs);
      this.selected = [];
      CommonHelper.swal(`${docs.length} recibo(s) assinado(s) com sucesso!`,"","success")
    },
    signedPreview(receiptId) {
      var url =
        process.env.VUE_APP_API_URL +
        "/Receipt/SignedPreview/?receiptId=" +
        receiptId;
      var link = document.createElement("a");
      link.id = "preview";
      link.href = url;
      link.download;
      link.click();
    },
    cancelReceipt(receiptId) {
      this.receiptService
        .cancelReceipt(receiptId)
        .then(this.cancelReceiptCallback);
    },
    batchCancelReceipt(receiptIds) {
      this.receiptService.batchCancelReceipt(receiptIds, this.cancelReceiptsCallback)
    },
    cancelReceiptCallback(){
      CommonHelper.swal("Recibo cancelado com sucesso!","","success")
      this.showCancelModal = false;
      this.loadPendingSignList()
    },
    cancelReceiptsCallback(){
      CommonHelper.swal("Recibos cancelados com sucesso!","","success")
      this.showCancelModal = false;
      this.selected = []
      this.loadPendingSignList()
    }
    
  }
};
</script>